import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Row, Space, List } from "antd";
import React, { useEffect, useState } from "react";
import NotFound from "../../../../components/common/notFound";
import FacotryIcon from "../../../../assets/images/dashbaord/factory.png";
import Logo from "../../../../assets/images/ieat_logo.png";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { SUCCESS_CODE } from "../../../../lib/const";
import {
  getDashboardCustomerSegment,
  getDashboardFutureCustomerSegment,
} from "../../../../services/dashboardService";
import "../style.css";

const Content = ({ future = false }) => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setLoadError(false);
    setDataSource([]);
    const fetchReport = future ? getDashboardFutureCustomerSegment : getDashboardCustomerSegment;
    fetchReport().then((res) => {
      if (res?.data?.code !== SUCCESS_CODE) throw new Error("Report failed");
      if (active) setDataSource(res.data.objectValue.dashboardCustomerSegmentDetailsList);
    }).catch(() => {
      if (active) setLoadError(true);
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => { active = false; };
  }, [future]);

  const onExportPDF = async (fileName) => {
    const input = document.getElementById("CUST_SEGMENT");
    html2canvas(input)
      .then((canvas) => {
        var imgData = canvas.toDataURL('image/png');
        var imgWidth = 210; 
        var pageHeight = 295;  
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;
        var doc = new jsPDF('p', 'mm');
        var position = 10; // give some top padding to first page
        
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        
        while (heightLeft >= 0) {
          position += heightLeft - imgHeight; // top padding for other pages
          doc.addPage();
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save(fileName);
      });

  };



  return (

    <>
<Row gutter={[24, 24]}>
          <Col span={20}></Col>
          <Col span={2}>
         
              <div>
                <Space>

                  <Button
                    disabled={loading || loadError || !dataSource.length}
                    onClick={() => onExportPDF(future ? "FutureCustomerSegmentProfile.pdf" : "CustomerSegmentProfile.pdf")}
                  >
                    <UploadOutlined /> Export PDF
                  </Button>

                </Space>
              
            </div>
          </Col>
          <Col span={2}></Col>
        </Row>
        <Row> <Col span={24}>&nbsp;</Col></Row>
      <div id="CUST_SEGMENT" className={"gutter-box"}>
        
        <Row>
          <Col span={4}></Col><Col span={16}><br /><div className="text-white-head-center"> Customer Segment Profile{future ? " (ลูกค้าอนาคต)" : ""}</div><br /><br /></Col><Col span={4}><img src={Logo} height={50} alt="I-EA-T LOGO" /></Col>
        </Row>

        <List
          id={"LIST_CUSTOMER_GROUP"}
          locale={{ emptyText: loadError ? "ไม่สามารถโหลดรายงานได้ กรุณาลองใหม่อีกครั้ง" : <NotFound /> }}
          loading={loading}
          rowKey={"key"}
          dataSource={dataSource}
          gutter={[24, 24]}
          backgroud-color={"#ff0000"}
          pagination={false}
          renderItem={(item, index) => (
            <List.Item id={"LIST_CUSTOMER_ITEM"} className={"gutter-box"}>
              {/* {console.log(item)} */}

              <Row gutter={[24, 24]}>
                <Col >&nbsp;</Col>
                <Col span={24}>
                  <div className={item.className}  >
                    <Row gutter={[24, 24]}  >
                      <Col span={1}></Col>
                      <Col span={3}>
                        &nbsp;

                        <img src={FacotryIcon} height={120} alt="Customer 0-3" />
                      </Col>
                      <Col span={8}>
                        <h2>{item.segmentName}</h2>
                      </Col>
                      <Col span={12}>
                        <span  ><h3>คุณลักษณะของผลิตภัณฑ์และบริการ</h3></span>
                        <div className="card bg-light shadow-sm">
                          <div className="card-body card-scroll h-200px">
                            {item.productAndServiceList_01.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )

                            })}
                          </div>

                        </div>
                        <div  >
                          <div >

                          </div>
                        </div>
                      </Col>

                    </Row>
                    <Row>
                      <Col span={11}>
                        <span  ><h3>ช่องทางการติดต่อสื่อสาร</h3></span>
                        <div className="card bg-light shadow-sm">

                          <div className="card-body card-scroll h-200px">
                            <b>1.)Touchpoint Based:</b> แบ่งเป็น 2 กลุ่ม <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;Digital Touchpoint มี 5 กลไกการรับฟัง ได้แก่ Website, Facebook, Twitter, LinkedIn, Weibo ระบบ I-EA-T e-PP, Email, Chat(Line Official, Lineกลุ่มผู้ประกอบการ, WeChat)<br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;Physical Touchpoint มี 3 กลไกการรับฟัง ได้แก่ โทรศัพท์ของสำนักงานใหญ่/สำนักงานนิคมอุตสาหกรรม, เอกสาร/จดหมาย/โทรสาร, การติดต่อโดยตรงที่สำนักงาน/TSC<br />
                            <b>2.) CRM Based:</b> มี 1 กลไกการรับฟัง ได้แก่ การเยี่ยมชมโรงงาน (Customer Visit)<br />
                            <b>3.) Survey Based:</b> มี 1 กลไกการรับฟัง ได้แก่การสำรวจความพึงพอใจ ความต้องการ ความคาดหวัง ความภักดี ประจำปี<br />

                          </div>

                        </div>

                      </Col>
                      <Col span={1}></Col>
                      <Col span={12}>
                        <span  ><h3>Pain Point</h3></span>
                        <div className="card bg-light shadow-sm">

                          <div className="card-body card-scroll h-200px ">
                            {item.painPointList_03.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                          </div>

                        </div>
                        <div  >
                          <div  >

                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={11}>
                        <span ><h3>ความต้องการ</h3></span>
                        <div className="card bg-light shadow-sm">
                          <div className="card-body card-scroll h-200px">
                            <b>ผลิตภัณฑ์และบริการหลัก</b><br />
                            {item.productAndServiceWantList_04.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                            <br /><b>บริการสนับสนุนและการจัดการความสัมพันธ์</b><br />
                            {item.supportWantList_04.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                            <br /><b>การทำธุรกรรม</b><br />
                            {item.transactionWantList_04.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                            <br /><b>การจัดการความสัมพันธ์</b><br />
                            {item.crmExpectedList_05.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                          </div>

                        </div>

                      </Col>
                      <Col span={1}></Col>
                      <Col span={12}>
                        <span  ><h3>ความคาดหวัง</h3></span>
                        <div className="card bg-light shadow-sm">

                          <div className="card-body card-scroll h-200px">
                            <b>ผลิตภัณฑ์และบริการหลัก</b><br />
                            {item.productAndServiceExpectedList_05.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                            <br /><b>บริการสนับสนุนและการจัดการความสัมพันธ์</b><br />
                            {item.supportExpectedList_05.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                            <br /><b>การทำธุรกรรม</b><br />
                            {item.transactionExpectedList_05.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                            <br /><b>การจัดการความสัมพันธ์</b><br />
                            {item.crmExpectedList_05.map(function (objItem, i) {
                              return (
                                <div>
                                  {objItem}
                                </div>
                              )
                            })}
                          </div>

                        </div>

                      </Col>
                    </Row>
                    <Row><Col span={24}>&nbsp;</Col></Row>
                  </div>
                </Col>
                <Col >&nbsp;</Col>
              </Row>

            </List.Item>
          )} />


      </div>
    </>
  );
};



export default Content;
